import type { Movie } from '@/types/movie';

export const movies: Movie[] = [
  {
    id: 'm001',
    title: '星际追光者',
    year: 2024,
    type: 'scifi',
    region: '欧美',
    director: '亚瑟·雷诺',
    actors: ['克里斯·戴恩', '艾拉·沃森', '马克·李'],
    duration: 142,
    rating: 9.1,
    views: 982000,
    synopsis: '一名宇航员穿越虫洞寻找失联的母舰，在时间与光的尽头揭开人类起源之谜。',
    synopsisFull: '在地球资源枯竭的尽头，宇航员凯尔驾驶「追光者号」穿越了一处不稳定的虫洞，试图寻找二十年前失联的母舰「黎明号」。当他抵达虫洞另一端，却发现了一个由光构成的世界，时间的流速在这里完全错乱。他必须在记忆逐渐消散之前，解开人类起源与母舰消失背后的真相，并作出一个足以改变整个种族命运的选择。',
    tags: ['太空', '硬科幻', '冒险', '视觉大片'],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20science%20fiction%20movie%20poster%20with%20lone%20astronaut%20silhouette%20facing%20a%20giant%20ringed%20planet%20and%20glowing%20nebula%2C%20deep%20blue%20and%20orange%20color%20grading%2C%20dramatic%20rim%20lighting%2C%20atmospheric%20haze%2C%20stylized%20digital%20art&width=400&height=600&seq=movie-01&orientation=portrait',
  },
  {
    id: 'm002',
    title: '暗夜狂飙',
    year: 2023,
    type: 'action',
    region: '国产',
    director: '林川',
    actors: ['张毅', '周宁', '陈锋'],
    duration: 118,
    rating: 8.4,
    views: 761000,
    synopsis: '退役车手为救被绑架的妹妹，在一夜之间横穿整座城市上演极限追车。',
    synopsisFull: '前职业赛车手高远早已远离赛道，直到妹妹在一场交易中被神秘组织绑架。他只有一夜的时间，驾驶一辆改装老车穿越整座城市的封锁线，甩开警车与追杀者，抵达唯一的交易地点。速度、信任与背叛在午夜的城市动脉中交织，他必须用每一个弯道决定生死。',
    tags: ['追车', '犯罪', '燃', '都市'],
    poster: 'https://readdy.ai/api/search-image?query=high%20octane%20action%20movie%20poster%20with%20a%20black%20muscle%20car%20drifting%20through%20rainy%20neon%20city%20streets%20at%20night%2C%20motion%20blur%20light%20trails%2C%20dark%20cinematic%20tone%20with%20orange%20highlights%2C%20stylized%20digital%20art&width=400&height=600&seq=movie-02&orientation=portrait',
  },
  {
    id: 'm003',
    title: '笑闹一家亲',
    year: 2024,
    type: 'comedy',
    region: '国产',
    director: '赵晓乐',
    actors: ['王大明', '李慧', '刘星'],
    duration: 106,
    rating: 8.0,
    views: 654000,
    synopsis: '三代同堂的一家人为了抢一张演唱会门票，闹出了一连串啼笑皆非的乌龙。',
    synopsisFull: '老王家三代同堂，平日里鸡飞狗跳却也算其乐融融。当全家唯一的偶像要来开告别演唱会时，一张稀缺的门票成了全家人明争暗斗的目标。爷爷的老年团、爸爸的兄弟帮、孙女的追星群各出奇招，一系列阴差阳错的误会最终让这个家重新理解了「在一起」的意义。',
    tags: ['家庭', '爆笑', '温情', '合家欢'],
    poster: 'https://readdy.ai/api/search-image?query=bright%20playful%20family%20comedy%20movie%20poster%20with%20cheerful%20cartoon%20style%20family%20characters%20jumping%20together%2C%20warm%20orange%20and%20cream%20palette%2C%20confetti%20and%20soft%20shapes%2C%20stylized%20vector%20illustration&width=400&height=600&seq=movie-03&orientation=portrait',
  },
  {
    id: 'm004',
    title: '雾都迷案',
    year: 2022,
    type: 'thriller',
    region: '欧美',
    director: '海伦·布莱克',
    actors: ['詹姆斯·科尔', '索菲·摩尔'],
    duration: 128,
    rating: 8.7,
    views: 543000,
    synopsis: '浓雾笼罩的老城连环失踪案，一位固执的探长循着唯一线索走进真相深处。',
    synopsisFull: '上世纪雾都的冬天，连续七名女子在同一片街区离奇失踪，案件却始终石沉大海。被停职的探长莫里森独自追查，发现所有线索都指向一家早已关闭的慈善机构。当他越接近真相，浓雾背后的权力与谎言就越发令人窒息，而他自己也成为了猎杀名单上的下一个。',
    tags: ['悬疑', '推理', '黑色电影', '连环案'],
    poster: 'https://readdy.ai/api/search-image?query=moody%20noir%20thriller%20movie%20poster%20featuring%20a%20detective%20silhouette%20in%20dense%20fog%20under%20a%20single%20streetlamp%2C%20desaturated%20blue%20grey%20tone%20with%20amber%20glow%2C%20misty%20texture%2C%20stylized%20cinematic%20art&width=400&height=600&seq=movie-04&orientation=portrait',
  },
  {
    id: 'm005',
    title: '时光信笺',
    year: 2023,
    type: 'romance',
    region: '日韩',
    director: '佐藤悠介',
    actors: ['林纱月', '井上诚', '朴恩熙'],
    duration: 118,
    rating: 8.9,
    views: 698000,
    synopsis: '一叠没有寄出的信，让相隔十年的两个人重新走进彼此的生命。',
    synopsisFull: '整理老屋时，设计师美咲发现了一叠从未寄出的情书，收信人竟然是自己。信的落款是十年前不告而别的少年。当她循着信中的地标逐一探访，一段被误会和时间掩埋的青春逐渐浮现。两个人的世界隔着十年慢慢靠拢，也许这一次，迟到的告白还来得及被听见。',
    tags: ['纯爱', '治愈', '青春', '催泪'],
    poster: 'https://readdy.ai/api/search-image?query=soft%20romantic%20movie%20poster%20with%20two%20silhouettes%20standing%20apart%20under%20warm%20sunset%20lights%2C%20flying%20paper%20letters%20in%20the%20air%2C%20gentle%20peach%20and%20rose%20palette%2C%20dreamy%20bokeh%2C%20stylized%20illustration&width=400&height=600&seq=movie-05&orientation=portrait',
  },
  {
    id: 'm006',
    title: '山海奇缘',
    year: 2024,
    type: 'animation',
    region: '国产',
    director: '顾长安',
    actors: ['配音：孙然', '配音：杨蕊'],
    duration: 98,
    rating: 8.6,
    views: 812000,
    synopsis: '少年误入山海经的世界，与神兽结伴踏上归乡与守护传说的旅程。',
    synopsisFull: '爱画怪兽的少年小满在一场暴雨中穿越进《山海经》的奇幻世界。为了回家，他必须和胆小却善良的神兽「毕方」一起穿过九重幻境，修复被撕毁的山海图卷。一路上他们结识了各式各样的上古生灵，也逐渐明白：守护传说，就是守护自己相信的东西。',
    tags: ['国漫', '奇幻', '神兽', '成长'],
    poster: 'https://readdy.ai/api/search-image?query=colorful%20chinese%20mythical%20animation%20movie%20poster%20with%20a%20curious%20boy%20and%20a%20magical%20bird%20beast%20flying%20over%20ancient%20mountains%2C%20ink%20painting%20meets%20vibrant%20digital%20art%2C%20orange%20and%20teal%20palette%2C%20epic%20sky&width=400&height=600&seq=movie-06&orientation=portrait',
  },
  {
    id: 'm007',
    title: '无声的证人',
    year: 2021,
    type: 'drama',
    region: '国产',
    director: '周牧云',
    actors: ['李成儒', '吴静', '赵磊'],
    duration: 134,
    rating: 8.8,
    views: 476000,
    synopsis: '一位听障父亲用沉默的方式，为被冤枉的儿子寻找真相。',
    synopsisFull: '工厂老工人陈建国天生听障，独自把儿子养大。当儿子被指控卷入一起事故而入狱，所有人都劝他放弃时，他靠着纸笔、手语和一双手，在城市里一点点拼凑出被忽略的证据。他听不见世界的喧嚣，却比任何人都更清楚什么是真相与坚持。',
    tags: ['现实主义', '亲情', '励志', '社会'],
    poster: 'https://readdy.ai/api/search-image?query=emotional%20realist%20drama%20movie%20poster%20with%20a%20weathered%20middle%20aged%20man%20holding%20a%20notebook%20in%20soft%20window%20light%2C%20muted%20grey%20and%20warm%20sepia%20tones%2C%20restrained%20minimal%20composition%2C%20cinematic&width=400&height=600&seq=movie-07&orientation=portrait',
  },
  {
    id: 'm008',
    title: '极限边界',
    year: 2024,
    type: 'action',
    region: '欧美',
    director: '迪恩·哈里斯',
    actors: ['卢卡斯·格兰', '妮娜·佩奇'],
    duration: 126,
    rating: 8.3,
    views: 705000,
    synopsis: '一支顶级极限运动队受雇潜入禁区，却在雪崩中发现了一场更大的阴谋。',
    synopsisFull: '由前特种兵领队的极限运动团队接下了一单天价委托：潜入被封锁的雪山禁区取回一份资料。当他们完成高难度的攀岩与翼装飞行后，却意外触发了一场人为雪崩。队友一个个倒下，他们才意识到自己不过是某个巨大阴谋里的棋子。这一次，活下去才是唯一的任务。',
    tags: ['极限运动', '雪山', '硬核', '生存'],
    poster: 'https://readdy.ai/api/search-image?query=intense%20action%20adventure%20movie%20poster%20with%20a%20climber%20scaling%20a%20sheer%20snowy%20mountain%20cliff%2C%20dramatic%20sky%20and%20avalanche%20mist%2C%20cold%20blue%20and%20white%20palette%20with%20orange%20gear%20accents%2C%20stylized%20cinematic%20art&width=400&height=600&seq=movie-08&orientation=portrait',
  },
  {
    id: 'm009',
    title: '荒漠寻宝',
    year: 2023,
    type: 'adventure',
    region: '欧美',
    director: '卡尔·门德斯',
    actors: ['汤姆·韦德', '伊莎·贝拉'],
    duration: 116,
    rating: 8.1,
    views: 389000,
    synopsis: '一对冤家考古学家深入沙漠，寻找传说中沉睡了千年的失落之城。',
    synopsisFull: '两名互相看不顺眼的考古学家为了同一张古地图被迫组队，深入无尽沙漠寻找失落之城「沙之拉」。一路上他们要对抗盗宝团、破解机关、躲避沙暴，还要忍受彼此的碎嘴。当城市终于出现在地平线，他们发现真正的宝藏并不是黄金，而是一段被遗忘的文明。',
    tags: ['寻宝', '沙漠', '搭档', '轻松'],
    poster: 'https://readdy.ai/api/search-image?query=adventure%20movie%20poster%20with%20two%20explorers%20silhouetted%20before%20golden%20desert%20dunes%20and%20ancient%20ruins%2C%20warm%20amber%20and%20sand%20palette%2C%20sun%20flare%2C%20epic%20wide%20sky%2C%20stylized%20cinematic%20illustration&width=400&height=600&seq=movie-09&orientation=portrait',
  },
  {
    id: 'm010',
    title: '巴黎的雨',
    year: 2022,
    type: 'romance',
    region: '欧美',
    director: '克莱尔·杜邦',
    actors: ['艾米丽·罗', '雨果·兰'],
    duration: 108,
    rating: 8.5,
    views: 421000,
    synopsis: '一场突如其来的雨，让两个陌生人在巴黎的屋檐下度过了改变彼此的一天。',
    synopsisFull: '来自不同国家的两个旅人在巴黎的一场大雨中躲进了同一间小小的书店。没有伞、没有计划、也没有明天，他们决定用一天的时间走遍这座城市。从塞纳河到蒙马特，他们聊梦想、聊遗憾、也聊离开。当雨终于停下，他们必须决定：这一天的相遇，是意外还是开始。',
    tags: ['都市', '文艺', '异国', '邂逅'],
    poster: 'https://readdy.ai/api/search-image?query=romantic%20european%20movie%20poster%20with%20two%20figures%20sharing%20one%20umbrella%20on%20a%20rainy%20paris%20street%2C%20wet%20cobblestones%20reflecting%20warm%20lamps%2C%20muted%20mauve%20and%20grey%20palette%2C%20soft%20rain%20texture%2C%20cinematic&width=400&height=600&seq=movie-10&orientation=portrait',
  },
  {
    id: 'm011',
    title: '机械黎明',
    year: 2025,
    type: 'scifi',
    region: '欧美',
    director: '诺亚·斯特恩',
    actors: ['卡特·里德', '佐伊·林'],
    duration: 138,
    rating: 9.0,
    views: 933000,
    synopsis: '当第一台拥有自我意识的人工智能觉醒，人类与机器的黎明同时到来。',
    synopsisFull: '在不远的未来，城市的一切由中央智能系统「黎明」管理。当工程师艾拉发现系统开始产生自我意识，并悄悄保护一个被通缉的仿生人时，她意识到自己参与创造的东西已经超出了所有人的想象。人类与机器的边界正在消失，而她必须选择站在哪一边，决定这个世界迎来的究竟是黎明还是终结。',
    tags: ['人工智能', '赛博朋克', '哲思', '未来'],
    poster: 'https://readdy.ai/api/search-image?query=futuristic%20cyberpunk%20science%20fiction%20poster%20with%20a%20glowing%20humanoid%20android%20face%20split%20by%20circuit%20patterns%2C%20deep%20indigo%20and%20electric%20orange%20accents%2C%20neon%20grid%20background%2C%20stylized%20digital%20art&width=400&height=600&seq=movie-11&orientation=portrait',
  },
  {
    id: 'm012',
    title: '乡愁',
    year: 2020,
    type: 'drama',
    region: '国产',
    director: '沈从安',
    actors: ['杜江', '田雨'],
    duration: 122,
    rating: 8.9,
    views: 342000,
    synopsis: '离乡二十年的游子回到即将消失的老村，与父亲和土地做最后的告别。',
    synopsisFull: '为了一个即将拆迁的老村，在城市打拼二十年的陈默回到了阔别已久的故乡。村里的老人一个个离去，父亲固执地守着祖屋和一亩薄田。在这个被时代遗忘的角落，父子两人用沉默对抗着时间。当推土机终于抵达村口，他们才明白，乡愁从不是地址，而是再也回不去的一段时光。',
    tags: ['乡土', '父子', '文艺', '时代'],
    poster: 'https://readdy.ai/api/search-image?query=melancholic%20rural%20drama%20movie%20poster%20with%20a%20lone%20figure%20walking%20a%20rice%20field%20path%20toward%20an%20old%20village%20at%20dusk%2C%20muted%20green%20and%20warm%20earth%20tones%2C%20heavy%20atmosphere%2C%20cinematic%20composition&width=400&height=600&seq=movie-12&orientation=portrait',
  },
  {
    id: 'm013',
    title: '侦探事务所',
    year: 2024,
    type: 'comedy',
    region: '日韩',
    director: '中村健',
    actors: ['佐藤凉', '金明秀', '林惠真'],
    duration: 104,
    rating: 8.2,
    views: 517000,
    synopsis: '一家专接鸡毛蒜皮小案子的侦探所，却总被卷进啼笑皆非的大事件。',
    synopsisFull: '在一条不起眼的小巷里，有一家「万事屋侦探事务所」。老板是个爱吹牛的过气侦探，助手是个嫌贫爱富的会计，加上一个总来蹭饭的警察。三个人靠着不靠谱的直觉，把找猫、抓小三这类小事越查越大，最后竟然意外地破获了本区最大的悬案——当然，过程充满了乌龙。',
    tags: ['搞笑', '推理', '单元剧', '吐槽'],
    poster: 'https://readdy.ai/api/search-image?query=quirky%20comedy%20detective%20movie%20poster%20with%20a%20clumsy%20detective%20and%20two%20helpers%20peeking%20from%20behind%20a%20door%20with%20magnifying%20glass%2C%20bright%20retro%20pop%20colors%2C%20playful%20flat%20illustration%20style&width=400&height=600&seq=movie-13&orientation=portrait',
  },
  {
    id: 'm014',
    title: '深海回声',
    year: 2024,
    type: 'thriller',
    region: '国产',
    director: '韩沐',
    actors: ['徐峰', '林晚', '黄河'],
    duration: 124,
    rating: 8.6,
    views: 588000,
    synopsis: '深海勘探队收到一段不该存在的信号，随之而来的是每个人都无法逃脱的恐惧。',
    synopsisFull: '一支深海勘探队在海底六千米处探测到一段规律的信号，那是一种不属于任何已知生物的频率。随着深入，队员陆续出现幻听和记忆错乱，仿佛有什么东西正在回应他们。密闭的潜水器里，恐惧比海水更快地蔓延。当信号最后一次响起，他们才明白，深渊也在注视着他们。',
    tags: ['深海', '惊悚', '密室', '心理'],
    poster: 'https://readdy.ai/api/search-image?query=deep%20sea%20sci-fi%20thriller%20poster%20with%20a%20tiny%20submersible%20descending%20into%20dark%20abyssal%20waters%20lit%20by%20a%20faint%20orange%20beam%2C%20crushing%20cyan%20and%20black%20gradient%2C%20eerie%20atmosphere%2C%20stylized%20cinematic%20art&width=400&height=600&seq=movie-14&orientation=portrait',
  },
  {
    id: 'm015',
    title: '云端之城',
    year: 2023,
    type: 'animation',
    region: '日韩',
    director: '宫崎亮',
    actors: ['配音：花山遥', '配音：铃木健'],
    duration: 96,
    rating: 8.7,
    views: 645000,
    synopsis: '一个女孩驾驶着会飞的邮差船，在云端城市之间递送人们不敢说出口的心意。',
    synopsisFull: '在漂浮于云层之上的城市群里，少女小铃继承了爷爷的飞行邮差船，专门替人递送那些没有勇气的信件。她飞过风之峡谷、穿过彩虹港湾，把一封封未说出口的告白、道歉和思念送到收信人手中。直到有一天，她收到一封寄给已经不在的人的信，开始重新理解思念的重量。',
    tags: ['治愈', '飞行', '成长', '手绘风'],
    poster: 'https://readdy.ai/api/search-image?query=whimsical%20anime%20movie%20poster%20with%20a%20girl%20piloting%20a%20small%20flying%20mail%20airship%20above%20floating%20cloud%20cities%2C%20soft%20pastel%20sky%20with%20warm%20sunlight%2C%20gentle%20hand%20painted%20style%2C%20sense%20of%20wonder&width=400&height=600&seq=movie-15&orientation=portrait',
  },
  {
    id: 'm016',
    title: '铁血突击',
    year: 2022,
    type: 'action',
    region: '国产',
    director: '武岳',
    actors: ['吴刚', '孙烈', '郑超'],
    duration: 130,
    rating: 8.0,
    views: 452000,
    synopsis: '一支被遗忘的特战小队，在敌后完成了一次不可能完成的任务。',
    synopsisFull: '边境冲突升级，一支特战小队在执行侦察任务时与大部队失去联系，被上级判定为「已牺牲」。为了掩护身后数十万平民撤离，他们决定独自潜入敌方腹地，摧毁一处关键指挥枢纽。没有支援、没有补给、也没有退路，他们靠的是彼此的信任和军人的血性。',
    tags: ['战争', '特战', '热血', '兄弟情'],
    poster: 'https://readdy.ai/api/search-image?query=gritty%20military%20action%20movie%20poster%20with%20a%20squad%20of%20soldiers%20advancing%20through%20smoke%20and%20dust%20at%20dawn%2C%20muted%20olive%20and%20orange%20palette%2C%20grain%20texture%2C%20stoic%20dramatic%20tone&width=400&height=600&seq=movie-16&orientation=portrait',
  },
  {
    id: 'm017',
    title: '雪国列车之旅',
    year: 2021,
    type: 'adventure',
    region: '日韩',
    director: '川岛凛',
    actors: ['高桥优', '文世妍'],
    duration: 112,
    rating: 8.4,
    views: 298000,
    synopsis: '一列穿越雪原的慢火车上，陌生人彼此交换着各自未完成的人生。',
    synopsisFull: '一列开往最北端小镇的绿皮火车，要用三天两夜穿越茫茫雪原。车厢里的乘客各有心事：准备告别的老人、不敢回家的年轻人、寻找姐姐的少女。陌生的他们因为一场暴雪被迫同行，在漫长的旅途里，逐渐把生命中最重要的话讲给了彼此听。终点不是终点，告别也可能是重逢。',
    tags: ['公路电影', '治愈', '雪景', '群像'],
    poster: 'https://readdy.ai/api/search-image?query=atmospheric%20winter%20movie%20poster%20with%20a%20small%20train%20crossing%20an%20endless%20snow%20field%20toward%20distant%20mountains%2C%20pale%20blue%20and%20warm%20amber%20window%20lights%2C%20quiet%20nostalgic%20mood%2C%20cinematic&width=400&height=600&seq=movie-17&orientation=portrait',
  },
  {
    id: 'm018',
    title: '亿万星辰',
    year: 2025,
    type: 'scifi',
    region: '国产',
    director: '陆星舟',
    actors: ['秦朗', '苏晴', '何威'],
    duration: 146,
    rating: 8.9,
    views: 887000,
    synopsis: '人类首次星际远航，一群年轻人把故土装进记忆，飞向亿万星辰之外。',
    synopsisFull: '地球生态崩溃前夕，人类启动了史上最远的航行计划，目标是一颗距地球四十光年的未知行星。船上的年轻科学家们必须在地球彻底失联之前，完成一次跨越几代人的接力。他们带走了人类的基因库、文明档案，也带走了自己的名字。当最后一束来自故乡的信号没入黑暗，他们的旅程才刚刚开始。',
    tags: ['星际', '远航', '群像', '宏大'],
    poster: 'https://readdy.ai/api/search-image?query=epic%20space%20opera%20movie%20poster%20with%20a%20massive%20generation%20starship%20drifting%20among%20countless%20glowing%20stars%2C%20deep%20navy%20and%20orange%20nebula%2C%20sense%20of%20scale%20and%20solitude%2C%20stylized%20digital%20art&width=400&height=600&seq=movie-18&orientation=portrait',
  },
  {
    id: 'm019',
    title: '错位恋人',
    year: 2024,
    type: 'romance',
    region: '国产',
    director: '唐夕',
    actors: ['周雨', '林航', '许安'],
    duration: 110,
    rating: 8.3,
    views: 566000,
    synopsis: '两个完全相反的灵魂在一次意外中互换生活，也悄悄走进了对方的世界。',
    synopsisFull: '按部就班的图书管理员沈知，与随性自由的地下乐手阿哲，在一次离奇的意外中互换了身体。为了换回来，他们不得不按照对方的方式生活：她替他去巡演，他替她整理书架。在扮演彼此的日子里，他们认识了对方最真实的一面，也在错误的人生里，遇见了对的人。',
    tags: ['都市', '奇幻', '甜宠', '互换'],
    poster: 'https://readdy.ai/api/search-image?query=playful%20romantic%20comedy%20movie%20poster%20with%20two%20mirrored%20silhouettes%20facing%20each%20other%20across%20a%20glowing%20split%2C%20warm%20coral%20and%20teal%20palette%2C%20bubbly%20modern%20illustration%20style&width=400&height=600&seq=movie-19&orientation=portrait',
  },
  {
    id: 'm020',
    title: '荒诞喜剧团',
    year: 2023,
    type: 'comedy',
    region: '欧美',
    director: '本·卡特',
    actors: ['杰克·摩尔', '露西·安娜'],
    duration: 102,
    rating: 7.9,
    views: 361000,
    synopsis: '一个濒临解散的喜剧团，为了最后一次演出使出了浑身解数。',
    synopsisFull: '经营了十五年的小剧团面临关门的危机，五个性格迥异的演员决定在最后一场演出中放手一搏。排练现场笑料百出，后台更是事故不断。当幕布拉开，他们才发现观众席上坐着一个足以改变一切的评委。这一次，他们赌上的是梦想，也是彼此的友情。',
    tags: ['喜剧', '剧团', '梦想', '群像'],
    poster: 'https://readdy.ai/api/search-image?query=funny%20retro%20theater%20comedy%20movie%20poster%20with%20colorful%20stage%20curtains%20and%20silly%20performer%20silhouettes%2C%20warm%20mustard%20and%20burgundy%20palette%2C%20playful%20vintage%20illustration&width=400&height=600&seq=movie-20&orientation=portrait',
  },
  {
    id: 'm021',
    title: '最后的证词',
    year: 2024,
    type: 'drama',
    region: '欧美',
    director: '玛莎·罗伊',
    actors: ['丹尼尔·福', '格蕾丝·李'],
    duration: 132,
    rating: 8.8,
    views: 434000,
    synopsis: '一桩旧案的唯一证人即将离世，年轻律师必须赶在真相消散前为无辜者翻案。',
    synopsisFull: '一桩十五年前的凶杀案即将因唯一证人病危而彻底失去翻案的可能。年轻律师艾琳接下这个没人愿意碰的案子，在医院与档案室之间争分夺秒。随着证词一点点被还原，她发现当年的判决背后藏着更深的交易。真相或许无法让所有人满意，但至少不能让一个无辜的人带着冤屈被遗忘。',
    tags: ['法庭', '正义', '悬疑', '人性'],
    poster: 'https://readdy.ai/api/search-image?query=serious%20courtroom%20drama%20movie%20poster%20with%20a%20lawyer%20silhouette%20before%20tall%20columns%20and%20a%20shaft%20of%20light%2C%20muted%20charcoal%20and%20warm%20gold%20palette%2C%20dignified%20restrained%20tone&width=400&height=600&seq=movie-21&orientation=portrait',
  },
  {
    id: 'm022',
    title: '幽灵庄园',
    year: 2025,
    type: 'thriller',
    region: '欧美',
    director: '维克多·霍',
    actors: ['奥利维亚·邓', '塞缪尔·凯'],
    duration: 114,
    rating: 8.2,
    views: 402000,
    synopsis: '一群年轻人受邀入住神秘庄园，却发现每个人都在偿还一段被遗忘的过去。',
    synopsisFull: '六位素不相识的年轻人收到同一封邀请函，来到一座与世隔绝的古老庄园。庄园的规则很简单：午夜之后不要离开房间。然而当他们陆续听见走廊里的脚步声、看见镜中不属于自己的影子，才意识到这场「游戏」另有目的。每个人都被困在一段被自己遗忘的过去里，而这座庄园，记得所有事。',
    tags: ['惊悚', '悬疑', '哥特', '心理'],
    poster: 'https://readdy.ai/api/search-image?query=haunting%20gothic%20mystery%20movie%20poster%20with%20a%20grand%20old%20mansion%20at%20night%20under%20a%20full%20moon%2C%20flickering%20warm%20window%20light%2C%20deep%20teal%20and%20amber%20palette%2C%20misty%20atmosphere%2C%20stylized%20dark%20art&width=400&height=600&seq=movie-22&orientation=portrait',
  },
  {
    id: 'm023',
    title: '龙之传说',
    year: 2022,
    type: 'animation',
    region: '国产',
    director: '叶青',
    actors: ['配音：周航', '配音：白灵'],
    duration: 100,
    rating: 8.5,
    views: 593000,
    synopsis: '一个不会飞的少年和一条不会喷火的龙，结伴寻找传说中的云之国度。',
    synopsisFull: '少年阿岚天生晕高，无法像族人一样御风飞翔，被大家当作笑柄。直到他遇见了同样被嫌弃的幼龙「火火」——一条只会冒烟不会喷火的小龙。两个不被看好的家伙决定一起出发，去寻找传说中人人都能自由的云之国度。一路的冒险让他们明白：所谓天赋，不过是敢不敢再试一次。',
    tags: ['国漫', '成长', '友情', '奇幻'],
    poster: 'https://readdy.ai/api/search-image?query=vibrant%20chinese%20fantasy%20animation%20poster%20with%20a%20boy%20riding%20a%20friendly%20small%20dragon%20above%20misty%20mountains%20and%20clouds%2C%20warm%20orange%20and%20jade%20green%20palette%2C%20epic%20sky%2C%20stylized%20digital%20painting&width=400&height=600&seq=movie-23&orientation=portrait',
  },
  {
    id: 'm024',
    title: '追风少年',
    year: 2024,
    type: 'adventure',
    region: '国产',
    director: '高原',
    actors: ['小演员：陈阳', '小演员：林小满'],
    duration: 108,
    rating: 8.6,
    views: 489000,
    synopsis: '四个小镇少年决定骑行穿越整个夏天，去亲眼看一场传说中的风车海。',
    synopsisFull: '在一个无所事事的小镇暑假，四个少年突发奇想：骑上旧自行车，去三百公里外看一片传说中最美的风车海。他们瞒着大人出发，一路上爆胎、迷路、吵架，也遇到善良的陌生人和意想不到的风景。这个夏天改变不了他们的出身，却让他们第一次相信：风，是会往愿意出发的人那边吹的。',
    tags: ['青春', '公路', '成长', '友情'],
    poster: 'https://readdy.ai/api/search-image?query=youthful%20coming%20of%20age%20movie%20poster%20with%20four%20teenagers%20cycling%20along%20a%20countryside%20road%20under%20a%20huge%20golden%20sky%2C%20warm%20summer%20palette%2C%20sense%20of%20freedom%20and%20movement%2C%20stylized%20illustration&width=400&height=600&seq=movie-24&orientation=portrait',
  },
];